import React, { useState, useEffect } from 'react'
import api from '../../api/axios'
import styles from './GenerateReport.module.css'
import { T, useContent } from '../../content/ContentProvider'

export function GenerateReport({ onSuccess, isLoading }) {
  const { t } = useContent()
  const [formData, setFormData] = useState({
    partnershipId: '',
    startDate: '',
    endDate: '',
  })
  const [partnerships, setPartnerships] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    fetchPartnerships()
  }, [])

  const fetchPartnerships = async () => {
    try {
      const response = await api.get('/api/admin/partnerships?size=100')
      const data = response.data
      setPartnerships(Array.isArray(data) ? data : data.content || [])
    } catch (err) {
      console.error('Failed to fetch partnerships:', err)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!formData.partnershipId || !formData.startDate || !formData.endDate) {
      setError(t('reports.generate.error.allFieldsRequired'))
      return
    }

    try {
      await api.post('/api/admin/reports/generate', formData)
      onSuccess()
      setFormData({ partnershipId: '', startDate: '', endDate: '' })
    } catch (err) {
      setError(err.response?.data?.message || t('reports.generate.error.failed'))
    }
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      {error && <div className={styles.error} role="alert" aria-live="polite">{error}</div>}

      <div className={styles.field}>
        <label><T k="reports.generate.field.partnership" /></label>
        <select
          name="partnershipId"
          value={formData.partnershipId}
          onChange={handleChange}
          required
          disabled={isLoading}
        >
          <option value="">{t('reports.generate.field.partnershipPlaceholder')}</option>
          {partnerships.map((partnership) => (
            <option key={partnership.id} value={partnership.id}>
              {partnership.agreementId} - {partnership.type}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <label><T k="reports.generate.field.startDate" /></label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
        </div>
        <div className={styles.field}>
          <label><T k="reports.generate.field.endDate" /></label>
          <input
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
        </div>
      </div>

      <div className={styles.actions}>
        <button type="submit" disabled={isLoading} className={styles.submitBtn}>
          {isLoading ? t('reports.generate.submitBusy') : t('reports.generate.submit')}
        </button>
      </div>
    </form>
  )
}
